import React from 'react';

import { Platform } from 'react-native';

import Link from 'components/link';
import { withTypography } from 'components/ui';

export const TermsLink = Link.withConfig({
  isInline: true,
  isUnderlined: true,
});

export const StyledText = withTypography({
  variant: 'copyOne',
  mx: '$2',
  style: Platform.select({ web: { display: 'inline-block' as any, marginRight: 0 } }),
});

export const OptInLabel: React.FC<React.PropsWithChildren<{ testID?: string }>> = ({
  testID,
  children,
}) => <StyledText testID={testID}>{children}</StyledText>;
